import {
  Listbox as HListBox,
  ListboxButton,
  ListboxOption,
  ListboxOptions,
} from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import classNames from 'classnames';

interface Props<T extends string | null> {
  options: Array<{ label: string; value: T }>;
  selected: T | undefined;
  setSelected: (value: T) => void;
  label?: string;
  disabled?: boolean;
  error?: string;
}

export function ListBox<T extends string>({
  options,
  selected,
  setSelected,
  label,
  disabled,
  error,
}: Props<T>) {
  return (
    <div className="space-y-2">
      {label && (
        <span className="text-body-medium font-semibold block">{label}</span>
      )}
      <HListBox {...(selected !== undefined ? { value: selected } : {})} onChange={setSelected}>
        <ListboxButton
          className={classNames(
            'group w-full -outline-offset-1 flex items-center justify-between border relative rounded-xs overflow-hidden border-grey-t-600 transition-all duration-100  data-active:outline-white data-active:outline-2 bg-background-secondary disabled:text-text-disabled py-3 px-3 h-10 text-left ',
            {
              'border-red-300': error?.length,
              'border-grey-t-700 text-text-disabled': disabled,
              'hover:border-white': !disabled,
            }
          )}
          disabled={!!disabled}
        >
          <span>
            {options.find((opt) => opt.value === selected)?.label ??
              '-- Select --'}
          </span>
          <ChevronDownIcon className="size-5 group-data-active:rotate-180 transition-all" />
        </ListboxButton>
        <ListboxOptions transition anchor="bottom start" className="bg-background-secondary mt-1 space-y-2 p-1 w-(--button-width) border rounded-xs border-grey-t-800 origin-top transition duration-200 ease-out data-closed:scale-95 data-closed:opacity-0">
          {options.map((opt) => (
            <ListboxOption
              value={opt.value}
              className="z-60 px-3 py-2.5 text-left hover:bg-grey-t-800 rounded-xs text-sm"
            >
              {opt.label}
            </ListboxOption>
          ))}
        </ListboxOptions>
      </HListBox>
    </div>
  );
}
